export const CHANGE = 'survey/create/open/CHANGE'
export const INIT = 'survey/create/open/INIT'

// 공개 상태 (policy getPolicyOpenStatus)
export type OpenStatus = 'open' | 'before_start' | 'closed'

export interface SurveyCreateOpenState {
    // 지금 응답을 받는지 (공개 && 시작 지남 && 종료 전)
    open: boolean;
    status: OpenStatus;
    // 공개 스위치에 저장된 값 그대로 (시작 전·종료 뒤에도 바뀌지 않는다)
    raw_open: boolean;
    end_date: number | '';
    end_date_used: boolean;
    start_date: number | '';
    start_date_used: boolean;
}

const initState: SurveyCreateOpenState = {
    open: false,
    status: 'closed',
    raw_open: false,
    end_date: '',
    end_date_used: false,
    start_date: '',
    start_date_used: false
}

export default (state = initState, action: { type: string } & SurveyCreateOpenState) => {
    switch(action.type) {
        case CHANGE:
            return {
                open: action.open,
                status: action.status,
                raw_open: action.raw_open,
                end_date: action.end_date,
                end_date_used: action.end_date_used,
                start_date: action.start_date,
                start_date_used: action.start_date_used
            }
        case INIT:
            return initState
        default:
            return state
    }
}
